// Copyright (c) 2016 Deere & Company

import './new-transfer-dealer.scss';
import Dealer from '../../../../sharedmodules/state/dealer';
import PropTypes from 'prop-types';
import React from 'react';
import { buildCityStateZip } from '../../shared/services/product';

const NewTransferDealerDetails = ({ dealer }) => (
    <section className="new-transfer-dealer-details">
        <div className="dealer-name">
            {`${dealer.name}, ${dealer.account}`}
        </div>
        <div className="dealer-address">
            {dealer.location.address1}
        </div>
        <div className="dealer-city-state-zip">
            {buildCityStateZip(dealer.location)}
        </div>
        <div className="dealer-email">
            {dealer.email}
        </div>
        <div className="dealer-phone">
            {dealer.phone}
        </div>
    </section>
);
NewTransferDealerDetails.displayName = 'NewTransferDealerDetails';
NewTransferDealerDetails.propTypes = {
    dealer: PropTypes.instanceOf(Dealer).isRequired,
};

export default NewTransferDealerDetails;
